import React, {useState, useEffect} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const RewardnominationEdit = ()=>{
     const [msisdn, setMsisdn ] = useState('');
     const [validfrom, setValidfrom ] = useState('');
     const [validuntil, setValiduntil ] = useState('');
     const [nominated, setNominated ] = useState('');
    const [redirect, setRedirect] = useState(false);
    
    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`rewardnomination/${id}`);
                 setMsisdn(data.msisdn);
                 setValidfrom(data.validfrom);
                 setValiduntil(data.validuntil);
                 setNominated(data.nominated);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`rewardnomination/${id}`, {
            msisdn,
            validfrom,
            validuntil,
            nominated,
        });
        console.log(data);
        setRedirect(true);
    };
   
    if(redirect){
         return <Navigate to={'/rewardnomination'} />
    }
    return (
        <Wrapper pageTitle={'Edit Rewardnomination'}>
            <InnerNav createLink={'/rewardnominationCreate'} listLink={'/rewardnomination'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn" value={msisdn}
                        onChange = {e => setMsisdn(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Validfrom </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Validfrom" value={validfrom}
                        onChange = {e => setValidfrom(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Validuntil </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Validuntil" value={validuntil}
                        onChange = {e => setValiduntil(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Nominated </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Nominated" value={nominated}
                        onChange = {e => setNominated(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default RewardnominationEdit;